module.exports = __webpack_public_path__ + "b29c74c5ffbdea1b6ad9424d38024319.png";